import { connect } from 'react-redux'
import myBoardSelector from './myBoardSelector'
import MyBoard from './MyBoard'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  myBoardSelector,
  {}
)(MyBoard))
